<template>
    <div>
        <el-row :gutter="20">
            <carousel :perPageCustom="[[320, 1],[360, 2],[536, 3],[768, 3],[1024, 4], [1280, 5],[1440, 5],[1680, 5]]"
                :autoplay="doAutoplay" :autoplay-timeout="3000" :pagination-enabled="paginationEnabled"
                :pagination-active-color="paginationActiveColor" :pagination-color="paginationColor"
                :pagination-padding="paginationPadding" autoplayDirection="backward">
                <slide>
                    <router-link :to="{name:'Cases'}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/cases.svg'" alt="cases-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Cases')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <p class="digit">{{ this.countData.data['cases'] }}</p>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
                <slide>
                    <router-link :to="{name:'Patenkinder'}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/paten.svg'" alt="contact-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Godchild')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <span class="digit">{{ this.countData.data['patenkinder'] }}</span>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
                <slide>
                    <router-link :to="{name:'Fachstellen'}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/fachs.svg'" alt="fachstellen-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Fachstellen')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <span class="digit">{{ this.countData.data['fachstellen'] }}</span>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
                <!-- <slide v-if="$store.state.config.user.role_slug.indexOf('admin') >= 0">
                    <router-link :to="{name:'Spenders'}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/doner.svg'" alt="spenders-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Spenders')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <span class="digit">{{ this.countData.data.spender }}</span>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide> -->
                <slide>
                    <router-link :to="{name:'Clubs'}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/club.svg'" alt="club-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{ $t('Clubs') }}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <span class="digit">{{ this.countData.data['club'] }}</span>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
            </carousel>
        </el-row>
        <section class="collapse-grid">
            <div class="grid-stack" data-gs-width="12" data-gs-height="0">
                <div v-if="layout[0]" class="grid-stack-item curv-chart" :data-gs-no-resize="(layout[0].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[0].isDraggable?'no':'yes')" :data-gs-x="layout[0].x" :data-gs-y="layout[0].y"
                    :data-gs-width="layout[0].w" :data-gs-height="layout[0].h" :data-gs-id="layout[0].i">
                    <div class="header">
                        <h1># {{ $t('Added Patenkinder / fachstellen / clubs') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <monthly-added-users-type-wise></monthly-added-users-type-wise>
                        </div>
                    </div>
                </div>
                <div v-if="layout[1]" class="grid-stack-item case-chart-dev" :data-gs-no-resize="(layout[1].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[1].isDraggable?'no':'yes')" :data-gs-x="layout[1].x" :data-gs-y="layout[1].y"
                    :data-gs-width="layout[1].w" :data-gs-height="layout[1].h" :data-gs-id="layout[1].i">
                    <div class="header">
                        <h1># {{ $t('Cases') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <monthly-case-status />
                        </div>
                    </div>
                </div>
                <div v-if="layout[2]" class="grid-stack-item pie-chart-grid" :data-gs-no-resize="(layout[2].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[2].isDraggable?'no':'yes')" :data-gs-x="layout[2].x" :data-gs-y="layout[2].y"
                    :data-gs-width="layout[2].w" :data-gs-height="layout[2].h" :data-gs-id="layout[2].i">
                    <div class="header">
                        <h1># {{ $t('Cases per Types') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <case-types></case-types>
                        </div>
                    </div>
                </div>
                <div v-if="layout[3]" class="grid-stack-item over-pie-chart-grid" :data-gs-no-resize="(layout[3].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[3].isDraggable?'no':'yes')" :data-gs-x="layout[3].x" :data-gs-y="layout[3].y"
                    :data-gs-width="layout[3].w" :data-gs-height="layout[3].h" :data-gs-id="layout[3].i">
                    <div class="header">
                        <h1>{{ $t('Over All Cases') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <overall-cases-count />
                        </div>
                    </div>
                </div>
                <div v-if="layout[4]" class="grid-stack-item recent-case" style="height:auto;" :data-gs-no-resize="(layout[4].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[4].isDraggable?'no':'yes')" :data-gs-x="layout[4].x" :data-gs-y="layout[4].y"
                    :data-gs-width="layout[4].w" :data-gs-height="layout[4].h" :data-gs-id="layout[4].i">
                    <div class="header">
                        <h1>{{ $t('Recent cases') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content recent-case">
                            <recent-cases :case-stages="caseStages" />
                        </div>
                    </div>
                </div>
                <div v-if="layout[5]" class="grid-stack-item curv-confirm-chart" :data-gs-no-resize="(layout[5].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[5].isDraggable?'no':'yes')" :data-gs-x="layout[5].x" :data-gs-y="layout[5].y"
                    :data-gs-width="layout[5].w" :data-gs-height="layout[5].h" :data-gs-id="layout[5].i">
                    <div class="header">
                        <h1>{{ $t('confirmed amount') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <monthly-confirmed-amount></monthly-confirmed-amount>
                        </div>
                    </div>
                </div>
                <div v-if="layout[6]" class="grid-stack-item map-grid" :data-gs-no-resize="(layout[6].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[6].isDraggable?'no':'yes')" :data-gs-x="layout[6].x" :data-gs-y="layout[6].y"
                    :data-gs-width="layout[6].w" :data-gs-height="layout[6].h" :data-gs-id="layout[6].i">
                    <div class="header">
                        <h1># {{ $t('fachstellen / clubs per Organisation') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <organization-wise-fachstellen-and-clubs :organization-list="organizationList"></organization-wise-fachstellen-and-clubs>
                        </div>
                    </div>
                </div>
                <div v-if="layout[7]" class="grid-stack-item case-amount-grid" :data-gs-no-resize="(layout[7].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[7].isDraggable?'no':'yes')" :data-gs-x="layout[7].x" :data-gs-y="layout[7].y"
                    :data-gs-width="layout[7].w" :data-gs-height="layout[7].h" :data-gs-id="layout[7].i">
                    <div class="header">
                        <h1># {{ $t('Cases / amount per Fachstellen') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <fachstellen-amount-cases :organization-list="organizationList" />
                        </div>
                    </div>
                </div>
                <div v-if="layout[8]" class="grid-stack-item amount-bar-chart" :data-gs-no-resize="(layout[8].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[8].isDraggable?'no':'yes')" :data-gs-x="layout[8].x" :data-gs-y="layout[8].y"
                    :data-gs-width="layout[8].w" :data-gs-height="layout[8].h" :data-gs-id="layout[8].i">
                    <div class="header">
                        <h1># {{ $t('Fachstellen wise patenkinder') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <fachstellen-patenkinder :organization-list="organizationList" />
                        </div>
                    </div>
                </div>
                <div v-if="layout[9]" class="grid-stack-item" :data-gs-no-resize="(layout[9].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[9].isDraggable?'no':'yes')" :data-gs-x="layout[9].x" :data-gs-y="layout[9].y"
                    :data-gs-width="layout[9].w" :data-gs-height="layout[9].h" :data-gs-id="layout[9].i">
                    <div class="header">
                        <h1># {{ $t('Country wise patenkinder') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <countrywise-patenkinder :organization-list="organizationList" />
                        </div>
                    </div>
                </div>
                <div v-if="layout[10]" class="grid-stack-item age-bar-chart" :data-gs-no-resize="(layout[10].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[10].isDraggable?'no':'yes')" :data-gs-x="layout[10].x" :data-gs-y="layout[10].y"
                    :data-gs-width="layout[10].w" :data-gs-height="layout[10].h" :data-gs-id="layout[10].i">
                    <div class="header">
                        <h1># {{ $t('patenkinder') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <agewise-patenkinder :organization-list="organizationList" />
                        </div>
                    </div>
                </div>
                <div v-if="layout[11]" class="grid-stack-item" :data-gs-no-resize="(layout[11].isResizable?'no':'yes')"
                    :data-gs-no-move="(layout[11].isDraggable?'no':'yes')" :data-gs-x="layout[11].x" :data-gs-y="layout[11].y"
                    :data-gs-width="layout[11].w" :data-gs-height="layout[11].h" :data-gs-id="layout[11].i">
                    <div class="header">
                        <h1># {{ $t('Year wise patenkinder') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <yearwise-patenkinder :organization-list="organizationList" />
                        </div>
                    </div>
                </div>
            </div>
            <el-col class="dash-butns" :lg="24">
                <el-button type="primary" @click="saveConfig">{{ $t('Save') }}</el-button>
                <el-button type="cancel" @click="resetConfig">{{ $t('Reset') }}</el-button>
            </el-col>
        </section>
    </div>
</template>
<style lang="scss">
    .grid-stack {
        margin: 0 -10px;
    }
</style>

<script>
    import Vue from 'vue';
    import VueCollapse from 'vue2-collapse';
    import gridstack from 'gridstack';
    Vue.use(VueCollapse);

    import MonthlyAddedUsersTypeWise from "../Widgets/chart/components/MonthlyAddedUsersTypeWise";
    import MonthlyConfirmedAmount from "../Widgets/chart/components/MonthlyConfirmedAmount";
    import OrganizationWiseFachstellenAndClubs from "../Widgets/chart/components/OrganizationWiseFachstellenAndClubs";
    import OverallCasesCount from "../Widgets/chart/components/OverallCasesCount";
    import MonthlyCaseStatus from "../Widgets/chart/components/MonthlyCaseStatus";
    import CaseTypes from "../Widgets/chart/components/CaseTypes";
    import RecentCases from "../Cases/RecentCases";
    import FachstellenAmountCases from "../Widgets/chart/components/FachstellenAmountCases";
    import FachstellenPatenkinder from "../Widgets/chart/components/FachstellenPatenkinder";
    import CountrywisePatenkinder from "../Widgets/chart/components/CountrywisePatenkinder";
    import AgewisePatenkinder from "../Widgets/chart/components/AgewisePatenkinder";
    import YearwisePatenkinder from "../Widgets/chart/components/YearwisePatenkinder";

    import {
        Carousel,
        Slide
    } from "vue-carousel";

    export default {
        components: {
            MonthlyAddedUsersTypeWise,
            RecentCases,
            MonthlyConfirmedAmount,
            OrganizationWiseFachstellenAndClubs,
            OverallCasesCount,
            MonthlyCaseStatus,
            CaseTypes,
            Carousel,
            Slide,
            FachstellenAmountCases,
            FachstellenPatenkinder,
            CountrywisePatenkinder,
            AgewisePatenkinder,
            YearwisePatenkinder
        },
        data() {
            return {
                layout: [],
                countData: {
                    data: {}
                },
                doAutoplay: false,
                paginationEnabled: true,
                isOpen: false,
                paginationActiveColor: 'var(--base-theme-color)',
                paginationColor: 'var(--table-theme-light-color)',
                paginationPadding: 5,
                options: {
                    handle: '.drag',
                    animate: true,
                    cellHeight: 10,
                },
                caseStages: {},
                organizationList: {}
            };
        },
        mounted() {
            setTimeout(() => {
                if (this.layout.length > 0) {
                    $('.grid-stack').gridstack(this.options);
                }
            }, 1500);
            $('.grid-stack').on('change', (event, items) => {
                if (items) {
                    this.layout = this.layout.map((item) => {
                        items.forEach(element => {
                            if (item.i == element.id) {
                                item.w = element.width;
                                item.h = element.height;
                                item.x = element.x;
                                item.y = element.y;
                            }
                        });
                        return item;
                    });
                    this.setPos();
                }
            });
            if (localStorage.getItem("layout") != null && localStorage.getItem("layout") !== 'undefined') {
                this.layout = JSON.parse(localStorage.getItem("layout"));
            } else {
                this.getConfig();
            }
            this.getAllCount();
            this.getAllOrganization();
            this.getCaseStages();
        },
        methods: {
            activateClass: function (event) {
                event.target.classList.toggle("open");
            },
            openInFullScreen(event) {
                const el = $(event.target).parents('.grid-stack-item')[0];
                if (screenfull.enabled) {
                    screenfull.toggle(el);
                }
            },
            getAllCount() {
                request({
                    url: "dashboard-get-all-count",
                    method: "get",
                    params: {}
                }).then(response => {
                    this.countData = response.data;
                });
            },
            getConfig(isReset = false) {
                this.$parent.fullscreenLoading = true;
                serverBus.$emit('loader', true);
                request({
                    url: "widgets",
                    method: "get",
                    params: {}
                }).then(response => {
                    if (isReset) {
                        //this.layout = response.data.data;
                        let layout = response.data.data;
                        localStorage.setItem("layout", JSON.stringify(layout));
                        setTimeout(() => {
                            $('.grid-stack').gridstack(this.options);
                            var grid =  $('.grid-stack').data('gridstack')
                            $('.grid-stack > div').each(function(i){
                                grid.update($(this), layout[i].x, layout[i].y, layout[i].w, layout[i].h)
                            })
                            this.$parent.fullscreenLoading = false;
                            this.layout = layout;
                        }, 1500);
                    } else {
                        this.layout = response.data.data;
                        setTimeout(() => {
                            $('.grid-stack').gridstack(this.options);
                        }, 1500);
                    }
                });
            },
            setPos() {
                localStorage.setItem("layout", JSON.stringify(this.layout));
            },
            resetConfig() {
                localStorage.removeItem("layout");
                this.getConfig(true);
            },
            saveConfig() {
                this.$root.$emit("loader", true);
                request({
                        url: "widgets",
                        method: "post",
                        data: this.layout
                    })
                    .then(response => {
                        this.$root.$emit("loader", false);
                        this.$notify({
                            title: this.$t("Success"),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$root.$emit("loader", false);
                        this.$notify({
                            title: "Error",
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            getAllOrganization() {
                request({
                    url: "get-all-organizations",
                    method: "get"
                }).then(response => {
                    this.organizationList = response.data;
                });
            },
            getCaseStages() {
                request({
                    url: "get-all-case-status",
                    method: "get"
                }).then(response => {
                    this.caseStages = response.data.data;
                })
                .catch(error => {
                    this.$notify({
                        title: this.$t('Error'),
                        message: error.response.data.message,
                        type: "error",
                        offset: 50
                    });
                });
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Layout/Dashboard/Dashboard.vue